import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';

/* ─────────────────────────────────────────────────────────────────────────
 * Wrapper global de fetch : injecte automatiquement l'en-tête
 * Authorization: Bearer <token> sur tous les appels vers l'API backend.
 * Cela couvre l'ensemble des appels existants sans les modifier un par un.
 * Si l'API renvoie 401 alors qu'un token est présent (token expiré/invalide),
 * la session locale est purgée et l'utilisateur est renvoyé vers /auth.
 * ───────────────────────────────────────────────────────────────────────── */
(function installAuthFetch() {
  const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
  if (!API_BASE || typeof window.fetch !== 'function') return;

  const originalFetch = window.fetch.bind(window);

  const urlOf = (input) => {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  };

  window.fetch = async function (input, init = {}) {
    let url = urlOf(input);
    const isApiCall = url.indexOf(API_BASE) === 0;

    if (isApiCall) {
      // Token passé en paramètre d'URL (le backend lit ?token=).
      if (typeof input === 'string') {
        const token = localStorage.getItem('token');
        if (token && url.indexOf('token=') === -1) {
          url += (url.indexOf('?') === -1 ? '?' : '&') + 'token=' + encodeURIComponent(token);
          input = url;
        }
      }
      // Header obligatoire pour franchir la page d'avertissement de ngrok free
      // (sinon ngrok renvoie une page HTML sans en-tête CORS). Le preflight
      // déclenché est autorisé par le .htaccess du backend.
      const headers = new Headers((init && init.headers) || {});
      headers.set('ngrok-skip-browser-warning', 'true');
      init = { ...init, headers };
    }

    const response = await originalFetch(input, init);

    // 401 sur un appel protégé : session absente/expirée -> reconnexion.
    // (Les pages publiques n'appellent pas d'endpoint protégé, pas de boucle.)
    if (isApiCall && response.status === 401 && window.location.pathname !== '/auth') {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/auth';
    }

    return response;
  };
})();

// Capture du lien d'affiliation : ?ref=CODE → localStorage (une seule fois).
(function captureRefCode() {
  try {
    const p = new URLSearchParams(window.location.search);
    const ref = p.get('ref');
    if (ref && /^[A-Z0-9_]{3,20}$/i.test(ref)) {
      localStorage.setItem('ref_code', ref.toUpperCase());
    }
  } catch {}
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
